webpackJsonp([239164364475077,121760929056902,119074515573302,126521735451307,184440655254632,268328026495954],{

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactCore = __webpack_require__(3);
	
	var _BodyText = __webpack_require__(191);
	
	var _BodyText2 = _interopRequireDefault(_BodyText);
	
	var _DataList = __webpack_require__(192);
	
	var _DataList2 = _interopRequireDefault(_DataList);
	
	var _Headings = __webpack_require__(193);
	
	var _Headings2 = _interopRequireDefault(_Headings);
	
	var _OrderedList = __webpack_require__(194);
	
	var _OrderedList2 = _interopRequireDefault(_OrderedList);
	
	var _UnorderedList = __webpack_require__(195);
	
	var _UnorderedList2 = _interopRequireDefault(_UnorderedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'Text',
	  components: {
	    TextContent: _reactCore.TextContent,
	    Text: _reactCore.Text,
	    TextList: _reactCore.TextList,
	    TextListItem: _reactCore.TextListItem
	  },
	  enumValues: {
	    'Object.values(TextVariants)': Object.values(_reactCore.TextVariants),
	    'Object.values(TextListVariants)': Object.values(_reactCore.TextListVariants),
	    'Object.values(TextListItemVariants)': Object.values(_reactCore.TextListItemVariants)
	  },
	  examples: [{ component: _Headings2.default, title: 'Headings Example' }, { component: _BodyText2.default, title: 'Body text examples' }, {
	    component: _UnorderedList2.default,
	    title: 'Unordered list example',
	    description: 'Text components such as Text, TextList, TextListItem need to be placed within a TextContent'
	  }, { component: _OrderedList2.default, title: 'Ordered list Example' }, { component: _DataList2.default, title: 'Data list example' }]
	};
	module.exports = exports['default'];

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BodyText = function (_React$Component) {
	  _inherits(BodyText, _React$Component);
	
	  function BodyText() {
	    _classCallCheck(this, BodyText);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BodyText.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.TextContent,
	      null,
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.p },
	        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque. Sub works as well!'
	      ),
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.p },
	        'Quisque ante lacus, malesuada ac auctor vitae, congue',
	        ' ',
	        _react2.default.createElement(
	          _reactCore.Text,
	          { component: _reactCore.TextVariants.a, href: '#' },
	          'non ante'
	        ),
	        '. Phasellus lacus ex, semper ac tortor nec, fringilla condimentum orci. Fusce eu rutrum tellus.'
	      ),
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.blockquote },
	        'Ut venenatis, nisl scelerisque sollicitudin fermentum, quam libero hendrerit ipsum, ut blandit est tellus sit amet turpis.'
	      ),
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.small },
	        'Sometimes you need small text to display things like date created'
	      )
	    );
	  };
	
	  return BodyText;
	}(_react2.default.Component);
	
	exports.default = BodyText;
	BodyText.__docgenInfo = {
	  'description': '',
	  'displayName': 'BodyText'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { TextContent, Text, TextVariants } from '@patternfly/react-core';\n\nclass BodyText extends React.Component {\n  render() {\n    return (\n      <TextContent>\n        <Text component={TextVariants.p}>\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla accumsan, metus ultrices eleifend gravida,\n          nulla nunc varius lectus, nec rutrum justo nibh eu lectus. Ut vulputate semper dui. Fusce erat odio,\n          sollicitudin vel erat vel, interdum mattis neque. Sub works as well!\n        </Text>\n        <Text component={TextVariants.p}>\n          Quisque ante lacus, malesuada ac auctor vitae, congue{' '}\n          <Text component={TextVariants.a} href=\"#\">\n            non ante\n          </Text>\n          . Phasellus lacus ex, semper ac tortor nec, fringilla condimentum orci. Fusce eu rutrum tellus.\n        </Text>\n        <Text component={TextVariants.blockquote}>\n          Ut venenatis, nisl scelerisque sollicitudin fermentum, quam libero hendrerit ipsum, ut blandit est tellus sit\n          amet turpis.\n        </Text>\n        <Text component={TextVariants.small}>Sometimes you need small text to display things like date created</Text>\n      </TextContent>\n    );\n  }\n}\n\nexport default BodyText;\n"

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataList = function (_React$Component) {
	  _inherits(DataList, _React$Component);
	
	  function DataList() {
	    _classCallCheck(this, DataList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DataList.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.TextContent,
	      null,
	      _react2.default.createElement(
	        _reactCore.TextList,
	        { component: _reactCore.TextListVariants.dl },
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          { component: _reactCore.TextListItemVariants.dt },
	          'Web'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          { component: _reactCore.TextListItemVariants.dd },
	          'The part of the Internet that contains websites and web pages'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          { component: _reactCore.TextListItemVariants.dt },
	          'HTML'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          { component: _reactCore.TextListItemVariants.dd },
	          'A markup language for creating web pages'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          { component: _reactCore.TextListItemVariants.dt },
	          'CSS'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          { component: _reactCore.TextListItemVariants.dd },
	          'A technology to make HTML look better'
	        )
	      )
	    );
	  };
	
	  return DataList;
	}(_react2.default.Component);
	
	exports.default = DataList;
	DataList.__docgenInfo = {
	  'description': '',
	  'displayName': 'DataList'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { TextContent, TextList, TextListVariants, TextListItem, TextListItemVariants } from '@patternfly/react-core';\n\nclass DataList extends React.Component {\n  render() {\n    return (\n      <TextContent>\n        <TextList component={TextListVariants.dl}>\n          <TextListItem component={TextListItemVariants.dt}>Web</TextListItem>\n          <TextListItem component={TextListItemVariants.dd}>\n            The part of the Internet that contains websites and web pages\n          </TextListItem>\n          <TextListItem component={TextListItemVariants.dt}>HTML</TextListItem>\n          <TextListItem component={TextListItemVariants.dd}>A markup language for creating web pages</TextListItem>\n          <TextListItem component={TextListItemVariants.dt}>CSS</TextListItem>\n          <TextListItem component={TextListItemVariants.dd}>A technology to make HTML look better</TextListItem>\n        </TextList>\n      </TextContent>\n    );\n  }\n}\n\nexport default DataList;\n"

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { TextContent, Text, TextVariants } from '@patternfly/react-core';\n\nclass Headings extends React.Component {\n  render() {\n    return (\n      <TextContent>\n        <Text component={TextVariants.h1}>Hello World</Text>\n        <Text component={TextVariants.h2}>Second level</Text>\n        <Text component={TextVariants.h3}>Third level</Text>\n        <Text component={TextVariants.h4}>Fourth level</Text>\n        <Text component={TextVariants.h5}>Fifth level</Text>\n        <Text component={TextVariants.h6}>Sixth level</Text>\n      </TextContent>\n    );\n  }\n}\n\nexport default Headings;\n"

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Headings = function (_React$Component) {
	  _inherits(Headings, _React$Component);
	
	  function Headings() {
	    _classCallCheck(this, Headings);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Headings.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.TextContent,
	      null,
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.h1 },
	        'Hello World'
	      ),
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.h2 },
	        'Second level'
	      ),
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.h3 },
	        'Third level'
	      ),
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.h4 },
	        'Fourth level'
	      ),
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.h5 },
	        'Fifth level'
	      ),
	      _react2.default.createElement(
	        _reactCore.Text,
	        { component: _reactCore.TextVariants.h6 },
	        'Sixth level'
	      )
	    );
	  };
	
	  return Headings;
	}(_react2.default.Component);
	
	exports.default = Headings;
	Headings.__docgenInfo = {
	  'description': '',
	  'displayName': 'Headings'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderedList = function (_React$Component) {
	  _inherits(OrderedList, _React$Component);
	
	  function OrderedList() {
	    _classCallCheck(this, OrderedList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  OrderedList.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.TextContent,
	      null,
	      _react2.default.createElement(
	        _reactCore.TextList,
	        { component: _reactCore.TextListVariants.ol },
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Donec blandit a lorem id convallis.'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Cras gravida arcu at diam gravida gravida.'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Integer in volutpat libero.'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Donec a diam tellus.'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Aenean nec tortor orci.'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Quisque aliquam cursus urna, non bibendum massa viverra eget.'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Vivamus maximus ultricies pulvinar.'
	        )
	      )
	    );
	  };
	
	  return OrderedList;
	}(_react2.default.Component);
	
	exports.default = OrderedList;
	OrderedList.__docgenInfo = {
	  'description': '',
	  'displayName': 'OrderedList'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { TextContent, TextList, TextListVariants, TextListItem } from '@patternfly/react-core';\n\nclass OrderedList extends React.Component {\n  render() {\n    return (\n      <TextContent>\n        <TextList component={TextListVariants.ol}>\n          <TextListItem>Donec blandit a lorem id convallis.</TextListItem>\n          <TextListItem>Cras gravida arcu at diam gravida gravida.</TextListItem>\n          <TextListItem>Integer in volutpat libero.</TextListItem>\n          <TextListItem>Donec a diam tellus.</TextListItem>\n          <TextListItem>Aenean nec tortor orci.</TextListItem>\n          <TextListItem>Quisque aliquam cursus urna, non bibendum massa viverra eget.</TextListItem>\n          <TextListItem>Vivamus maximus ultricies pulvinar.</TextListItem>\n        </TextList>\n      </TextContent>\n    );\n  }\n}\n\nexport default OrderedList;\n"

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnorderedList = function (_React$Component) {
	  _inherits(UnorderedList, _React$Component);
	
	  function UnorderedList() {
	    _classCallCheck(this, UnorderedList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  UnorderedList.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.TextContent,
	      null,
	      _react2.default.createElement(
	        _reactCore.TextList,
	        null,
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'In fermentum leo eu lectus mollis, quis dictum mi aliquet.'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Morbi eu nulla lobortis, lobortis est in, fringilla felis.'
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Aliquam nec felis in sapien venenatis viverra fermentum nec lectus.',
	          _react2.default.createElement(
	            _reactCore.TextList,
	            null,
	            _react2.default.createElement(
	              _reactCore.TextListItem,
	              null,
	              'In fermentum leo eu lectus mollis, quis dictum mi aliquet.'
	            ),
	            _react2.default.createElement(
	              _reactCore.TextListItem,
	              null,
	              'Morbi eu nulla lobortis, lobortis est in, fringilla felis.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactCore.TextListItem,
	          null,
	          'Ut non enim metus.'
	        )
	      )
	    );
	  };
	
	  return UnorderedList;
	}(_react2.default.Component);
	
	exports.default = UnorderedList;
	UnorderedList.__docgenInfo = {
	  'description': '',
	  'displayName': 'UnorderedList'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { TextContent, TextList, TextListItem } from '@patternfly/react-core';\n\nclass UnorderedList extends React.Component {\n  render() {\n    return (\n      <TextContent>\n        <TextList>\n          <TextListItem>In fermentum leo eu lectus mollis, quis dictum mi aliquet.</TextListItem>\n          <TextListItem>Morbi eu nulla lobortis, lobortis est in, fringilla felis.</TextListItem>\n          <TextListItem>\n            Aliquam nec felis in sapien venenatis viverra fermentum nec lectus.\n            <TextList>\n              <TextListItem>In fermentum leo eu lectus mollis, quis dictum mi aliquet.</TextListItem>\n              <TextListItem>Morbi eu nulla lobortis, lobortis est in, fringilla felis.</TextListItem>\n            </TextList>\n          </TextListItem>\n          <TextListItem>Ut non enim metus.</TextListItem>\n        </TextList>\n      </TextContent>\n    );\n  }\n}\n\nexport default UnorderedList;\n"

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.text_package = exports.text_docs = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextDocs = __webpack_require__(546);
	
	var _TextDocs2 = _interopRequireDefault(_TextDocs);
	
	var _componentDocs = __webpack_require__(15);
	
	var _componentDocs2 = _interopRequireDefault(_componentDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rawExamples = [{ name: 'BodyText', path: '../../react-core/src/components/Text/examples/BodyText.js', file: __webpack_require__(437) }, { name: 'DataList', path: '../../react-core/src/components/Text/examples/DataList.js', file: __webpack_require__(438) }, { name: 'Headings', path: '../../react-core/src/components/Text/examples/Headings.js', file: __webpack_require__(439) }, { name: 'OrderedList', path: '../../react-core/src/components/Text/examples/OrderedList.js', file: __webpack_require__(440) }, { name: 'UnorderedList', path: '../../react-core/src/components/Text/examples/UnorderedList.js', file: __webpack_require__(441) }];
	var images = [{ name: 'img_avatar.svg', file: __webpack_require__(7) }, { name: 'l_pf-reverse-164x11.png', file: __webpack_require__(8) }, { name: 'pf_logo.svg', file: __webpack_require__(9) }, { name: 'pf_mini_logo_white.svg', file: __webpack_require__(10) }, { name: 'img_avatar.svg', file: __webpack_require__(12) }, { name: 'pf_logo.svg', file: __webpack_require__(13) }, { name: 'pf_logo_color.svg', file: __webpack_require__(14) }, { name: 'pfbg_992.jpg', file: __webpack_require__(11) }];
	
	var text_docs = exports.text_docs = _TextDocs2.default;
	var text_package = exports.text_package = 'react-core';
	
	exports.default = function () {
	    return _react2.default.createElement(_componentDocs2.default, _extends({ rawExamples: rawExamples, images: images }, _TextDocs2.default));
	};

/***/ })

});


// WEBPACK FOOTER //
// component---tmp-text-docs-js-6a2b54ac2acfa63d8aca.js